import axios from "axios";
import {config} from ".";
import {SERVER_URL} from "../../../constants/ClientConfig";
import {trackClickEvent, trackPageLoad} from "../../../utils/railsAnalytics";
import { generateId } from '../../../utils/trainUtils';

export const getMmtId = () => {
  return JSON.parse(localStorage.getItem("currentMMTBookingId"));
}

export const submit = async (pageId, data) => {
  const traceId = generateId();
  const url = constructUrl(pageId, "POST");
  const headers = {"X-Trace-Id": traceId};
  const response = await axios.post(url, {
    ...data,
    mmtId: getMmtId(),
    pageId,
  },{ headers });
  if (response.status === 200) {
    return {
      status: config.STATUS.D,
      message: 'Thank you for your feedback. Your feedback helps us to keep improving our product.'
    }
  } else {
    return {
      status: config.STATUS.F,
      message: 'Error'
    }
  }
};

export const constructUrl = (pageId, type) => {
  if (type === "GET") {
    switch (pageId) {
      case config.PAGE_ID.CANCEL_BOOKING:
      case config.PAGE_ID.WRONG_CREDENTIALS:
      case config.PAGE_ID.OTHER_ISSUES:
        return {
          url: `${SERVER_URL}/getContent`,
          payload: {
            pageId
          }
        };
      case config.PAGE_ID.BOOKING_DETAILS:
        return {
          url: `${SERVER_URL}/getBookingDetails`,
          payload: {
            bookingId: getMmtId(),
          }
        };
      default:
        return "";
    }
  } else {
    switch (pageId) {
      case config.PAGE_ID.CANCEL_BOOKING:
      case config.PAGE_ID.OTHER_ISSUES:
        return `${SERVER_URL}/postContent`;
      default:
        return '';
    }
  }
};

export const isTextQuestion = (questionId) => {
  return config.TEXT_AREA_QUESTIONS.includes(questionId);
}

export const trimTrailingSpaces = (value) => {
  return value.replace(/ +$/, "");
};

export const trackPage = (pageName) => {
  trackPageLoad(pageName);
}

export const trackClick = (pageName, id) => {
  trackClickEvent(pageName, id);
}
